import { assert } from '@sama/js-core';
import { forEach } from 'lodash';
import { ObjectState } from '../../../../../cross-team-shared/annotation/shared/state/object-state';
import { strictValues } from '../../../../../cross-team-shared/misc-utils/strict-record';
import { DeleteObjectOperation } from '../../../../../team-apis/otterdam/annotation-operations/object-operations';
import { DeleteObjectLocationOperationBuilder } from './delete-object-location-operation-builder';
import { ObjectOperationBuilderParams } from './object-operation-builder-params';

export function createDeleteObjectOperationBuilders(
  params: ObjectOperationBuilderParams,
) {
  const { previousObject, currentObject } = params;
  let deleteLocationBuilders: DeleteObjectLocationOperationBuilder[] = [];

  if (previousObject && !currentObject) {
    const frameNumbersToDelete = new Set<number>();
    forEach(strictValues(previousObject.dynamic_tags), (dynamic_tag) => {
      forEach(dynamic_tag, (location) => {
        frameNumbersToDelete.add(location.frame_number);
      });
    });
    deleteLocationBuilders = Array.from(frameNumbersToDelete).map(
      (frameNumber) =>
        new DeleteObjectLocationOperationBuilder(frameNumber, previousObject),
    );
  }

  return [...deleteLocationBuilders, new DeleteObjectOperationBuilder(params)];
}

export class DeleteObjectOperationBuilder {
  private currentObject?: ObjectState;
  private previousObject?: ObjectState;

  constructor({ currentObject, previousObject }: ObjectOperationBuilderParams) {
    this.currentObject = currentObject;
    this.previousObject = previousObject;
  }

  canBuild() {
    return !this.currentObject && !!this.previousObject;
  }

  build(): DeleteObjectOperation {
    assert(
      this.previousObject,
      'Previous object should be defined for delete operation',
    );
    return {
      operation: 'DELETE_OBJECT',
      ids: { objectId: this.previousObject.index },
    };
  }
}
